import {useRef } from "react";

const DatePicker = ({ value, onChange, minDate, maxDate }) => {
  const inputRef = useRef(null);

  return (
    <div>
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min={minDate}
        max={maxDate}
        ref={inputRef}
        onClick={() => inputRef.current?.showPicker()}
      />
    </div>
  );
};

export default DatePicker;